import React, { useState } from 'react';
import { subscribeNewsletter } from '../../utils/api';
import { toast } from 'sonner';
import './NewsletterSection.css';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    try {
      const response = await subscribeNewsletter(email);
      setIsSubscribed(true);
      setEmail('');
      
      if (response.message === 'Already subscribed') {
        toast.info('You\'re already subscribed!');
      } else {
        toast.success('Successfully subscribed to our newsletter!');
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to subscribe. Please try again.';
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="newsletter-section" data-testid="newsletter-section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-icon">
            <span className="icon-dash"></span>
            <span>Stay Close</span>
          </div>
          
          <h2 className="newsletter-title">Get the next drop first</h2>
          <p className="newsletter-description">
            Join the AMR list for new releases, events, artist updates, exclusive drops, and what's coming next.
          </p>

          {isSubscribed ? (
            <div className="newsletter-success" data-testid="newsletter-success">
              <p>Thanks for subscribing. Welcome to the family.</p>
            </div>
          ) : (
            <form className="newsletter-form" onSubmit={handleSubmit} data-testid="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input"
                required
                disabled={isSubmitting}
                data-testid="newsletter-email-input"
              />
              <button 
                type="submit" 
                className="newsletter-submit"
                disabled={isSubmitting}
                data-testid="newsletter-submit-btn"
              >
                {isSubmitting ? 'Joining...' : 'Join the List'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
